import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { deepClone, getDateFromString, getDateStringFromDate, getToday } from '@lx/shared/utils';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { CalendarModule } from 'primeng/calendar';
import { Observable } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { AsyncPipe, NgClass } from '@angular/common';
import { FormFieldComponent } from '@lx/shared/ui/form-field';
import { DropdownModule } from 'primeng/dropdown';
import { UiModule } from '@lx/ui/components';
import { ButtonModule } from 'primeng/button';
import { CalendarFieldComponent } from '@lx/shared/ui/calendar-field';
import { BreakpointObserverService } from '@lx/shared/utils-dom';
import { DatePickerFieldDate, DatePickerFieldMonthAndYear } from '@lx/quote-tool/shared/types';

@Component({
  standalone: true,
  selector: 'lx-date-picker-field',
  templateUrl: './date-picker-field.component.html',
  styleUrls: ['./date-picker-field.component.scss'],
  imports: [CalendarModule, FormsModule, NgClass, FormFieldComponent, DropdownModule, UiModule, CalendarFieldComponent, ButtonModule, AsyncPipe],
})
export class DatePickerFieldComponent implements OnInit, OnChanges {
  @ViewChild(CalendarFieldComponent) calendarFieldComponent: CalendarFieldComponent;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() disabled: boolean;
  @Input() required = false;
  @Input() isValid: boolean;
  @Input() dateValue: string;
  @Input() dateObject: Date;
  @Input() defaultDate = getToday();
  @Input() minDate: Date;
  @Input() maxDate: Date;
  @Input() disabledDates: Date[];
  @Input() disabledDays: number[];
  @Input() showCalendarIcon: boolean;
  @Input() yearRange: string;
  @Input() iconValidation = false;
  @Input() googleAnalyticsClickEvent: string | undefined;
  @Output() dateChanged = new EventEmitter<DatePickerFieldDate>();
  @Output() calendarShown = new EventEmitter<DatePickerFieldDate>();
  @Output() monthChanged = new EventEmitter<DatePickerFieldMonthAndYear>();
  @Output() datePickerFocused = new EventEmitter<void>();

  today = getToday();
  pickedDate: DatePickerFieldDate = {} as DatePickerFieldDate;
  mobileMode$: Observable<boolean> | undefined;

  private readonly breakpointObserverService = inject(BreakpointObserverService);

  ngOnInit(): void {
    this.mobileMode$ = this.breakpointObserverService.isMobile$;
  }

  ngOnChanges({ dateValue, dateObject }: SimpleChanges): void {
    if (dateValue) {
      this.pickedDate = {
        dateString: dateValue.currentValue,
        dateObject: getDateFromString(dateValue.currentValue),
      };
    }

    if (dateObject) {
      this.pickedDate = {
        dateString: getDateStringFromDate(dateObject.currentValue),
        dateObject: deepClone(dateObject.currentValue),
      };
    }
  }

  checkIsValid() {
    return this.isValid ?? (this.pickedDate?.dateObject ? true : null);
  }

  openCalendar() {
    this.calendarFieldComponent.openCalendar();
  }

  pickDate(date: Date) {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setUTCMilliseconds(0);

    this.pickedDate = {
      dateString: getDateStringFromDate(date),
      dateObject: date,
    };
    this.dateChanged.emit(this.pickedDate);
  }
}
